import { render, staticRenderFns } from "./BetgameCopy.vue?vue&type=template&id=09be4832&scoped=true"
import script from "./BetgameCopy.vue?vue&type=script&lang=js"
export * from "./BetgameCopy.vue?vue&type=script&lang=js"
import style0 from "./BetgameCopy.vue?vue&type=style&index=0&id=09be4832&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09be4832",
  null
  
)

export default component.exports